const getApiBaseUrl = (): string => {
  // Mobile access via local network IP
  if (window.location.hostname === '192.168.1.114') {
    return 'http://192.168.1.114:5001/api'
  }
  
  // In production, use the full URL from environment variable
  if (import.meta.env.PROD) {
    return import.meta.env.VITE_API_BASE_URL || 'https://api.symphonytodo.com/api'
  }
  
  // In development, use relative path (will be proxied by Vite)
  return '/api'
}

export const API_CONFIG = {
  baseUrl: getApiBaseUrl(),
  timeout: 30000,
}

export const getApiUrl = (endpoint: string): string => {
  // Remove leading slash if present
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint
  
  // In development, return relative path for proxy
  if (import.meta.env.DEV) {
    return `/api/${cleanEndpoint}`
  }
  
  // In production, return full URL
  return `${API_CONFIG.baseUrl}/${cleanEndpoint}`
}

export const getSignalRUrl = (): string => {
  if (import.meta.env.DEV) {
    // In development, use proxy
    return `${window.location.origin}/hubs/todo`
  }
  
  // In production, use the nginx proxy (same origin)
  return `${window.location.origin}/hubs/todo`
}

// Default export for easier imports
export default {
  API_CONFIG,
  getApiUrl,
  getSignalRUrl
}
